import clsx from "clsx";
import React from "react";

interface ShineBackgroundProps extends React.HTMLAttributes<HTMLDivElement> {
  duration?: number;
  shineColor?: string | string[];
  className?: string;
  style?: React.CSSProperties;
}

export function ShineBackground({
  duration = 4,
  shineColor = ["#A07CFE", "#FE8FB5", "#FFBE7B"],
  className,
  style,
  ...props
}: ShineBackgroundProps) {
  return (
    <div
      style={
        {
          "--duration": `${duration}s`,
          backgroundImage: `linear-gradient(90deg, transparent, ${
            Array.isArray(shineColor) ? shineColor.join(",") : shineColor
          } )`,
          backgroundSize: "200% 100%",
          ...style,
        } as React.CSSProperties
      }
      className={clsx(
        "absolute inset-0 size-full will-change-[background-position] motion-safe:animate-shine-right",
        className
      )}
      {...props}
    />
  );
}
